var fails = require('../internals/fails');

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/function-bind-native.js
// module id = 176
// module chunks = 0